// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ImageFallback_wrap__3VXUV","body":"ImageFallback_body__UgBLm"};